<script>
  import RichText from "$lib/components/RichText.svelte";
  import SocialBar from "$lib/islands/Components/SocialBar.svelte";
  import Heading from "$lib/components/Heading.svelte";
  import ImageComponent from "$lib/contentTypes/ImageComponent.svelte";

  import PageBody from "$lib/components/Page/PageBody.svelte";
  import Link from "$lib/components/Link.svelte";
  import Island from "$lib/components/Island.svelte";

  export let page;

  // let tags = {
  //   Tags: page.fields.pageData.fields.contentTags?.map((contentTag) => {
  //     return contentTag.fields.name;
  //   })
  // };
  let program = page.fields.pageData.fields.parentInfo?.headline;
  let programLink = page.fields.pageData.fields.parentInfo?.relativeUrl;
</script>

<!-- profile -->
<div class="w-full lg:max-w-screen-lg flex flex-col md:flex-row md:pr-175 lg:px-0 m-auto">
  <!-- photo -->
  {#if page.fields.imageComponent}
    <ImageComponent
      containerClass="flex-shrink-0 self-center md:self-start px-54 lg:pl-70 pt-48 lg:pt-94 lg:pr-0 md:left-[-15%] lg:left-0 relative"
      elementClass="w-252 lg:w-575 aspect-square object-cover rounded-full md:clip-left lg:clip-none"
      data={page.fields.imageComponent}
      displayCaption={false}
      resizeParams={{ fit: "scale" }}
      containerized={true}
      sm={"252px"}
      lg={"575px"}
      responsive
    />
  {/if}

  <!-- details -->
  <div class="grow w-full flex flex-col px-24 py-48 lg:p-72 gap-y-16 lg:gap-y-24">
    <Heading class="heading-2 !text-size-24 lg:!text-size-56" text={page.fields.name} />

    <Link
      class="max-w-max text-size-16 lg:text-size-24 px-0 py-0"
      url={programLink}
      text={program}
    />

    {#if page.fields.role || page.fields.location}
      <div class="pt-8 lg:pt-24 flex flex-col gap-y-24 lg:text-size-20">
        {#if page.fields.role}
          <h2 class="sr-only">Role</h2>
          <p>{page.fields.role}</p>
        {/if}

        {#if page.fields.location}
          <h2 class="sr-only">Location</h2>
          <p>{page.fields.location}</p>
        {/if}
      </div>
    {/if}

    <Island component={SocialBar} name="SocialBar" class="pt-8 lg:pt-24 !justify-start" />

    <div class="pt-32 lg:pt-24 flex flex-col gap-24">
      <!-- {#if tags && tags.Tags}
        <PageDetails props={tags} />
      {/if}

      {#if page.fields.pronouns}
        <h2 class="sr-only">Pronouns</h2>
        <p>{page.fields.pronouns}</p>
      {/if}

      {#if page.fields.issueAreas}
        <h2 class="sr-only">Issue Areas</h2>
        <p>{page.fields.issueAreas}</p>
      {/if}

      {#if page.fields.mission}
        <h2 class="sr-only">Mission</h2>
        <p>{page.fields.mission}</p>
      {/if} -->

      <!-- bio -->
      {#if page.fields.fullBio != null}
        <h2 class="sr-only">Biography</h2>
        <div>
          <RichText node={page.fields.fullBio} class="!mx-0" />
        </div>
      {/if}
    </div>
  </div>
</div>

{#if page.fields.trailingBody}
  <PageBody body={page.fields.trailingBody} class="last-page-element" />
{/if}
